import { _session } from '@/utils/localStorage'

const state = {
  sidebar: {
    // opened: _session.get('sidebarStatus') === null || parseInt(_session.get('sidebarStatus')) === 0,
    // 浏览器专用
    opened: 0,
    withoutAnimation: false
  },
  device: 'desktop'
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (!state.sidebar.opened) {
      _session.set('sidebarStatus', 1)
    } else {
      _session.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    // state.sidebar.opened = _session.get('sidebarStatus') === null || parseInt(_session.get('sidebarStatus')) === 0
    // 浏览器专用
    state.sidebar.opened = 0
    state.device = device
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
